import type { AgentCreate } from "@/types/agent";
import type { AgentBuilderResult } from "@/types/builder";

/**
 * Map an AI-builder-produced agent config into the `AgentCreate` payload the
 * agents API expects.
 *
 * The builder result comes from an LLM and, despite the TypeScript types, may
 * arrive with `toolConfigs` / `dataCollectionUuids` missing (undefined). These
 * are defensively defaulted to empty arrays so callers never throw when mapping.
 */
export function toAgentCreatePayload(config: AgentBuilderResult, teamUuid: string): AgentCreate {
  return {
    name: config.name,
    description: config.description,
    systemPrompt: config.systemPrompt,
    modelId: config.modelId,
    icon: config.icon,
    color: config.color,
    teamUuid,
    toolConfigs: (config.toolConfigs ?? []).map((tc) => ({
      toolUuid: tc.toolUuid,
      isEnabled: tc.isEnabled,
    })),
    dataCollectionIds: config.dataCollectionUuids ?? [],
  };
}
